




























import { Component, Vue } from 'vue-property-decorator';
import ApiRoutes from '@/logic/ApiRoutes';
import ApiHandler from '@/logic/ApiHandler';
import GlobalEvents from '@/logic/GlobalEvents';
import Performance from '@/types/Performance';
import LanguageHandler from '@/localisation/LanguageHandler';

@Component
export default class PerformanceList extends Vue {
    private loading = false;
    private performances: Performance[] = [];

    private created() {
        this.fetchPerformances();
    }

    private mounted() {

        // Attach listener for pull-refresh
        GlobalEvents.$on('local-refresh', () => {
            this.fetchPerformances()
                .then(() => GlobalEvents.$emit('local-refresh-done'));
        });
    }

    private beforeDestroy() {
        // Detach global listeners
        GlobalEvents.$off('local-refresh');
    }

    private selectPerformance(id: number) {

        // Save selection to store
        this.$store.dispatch('settings/setPerformance', id);

        // Go to performance view
        this.$router.push('/performance/');
    }

    private async localRefresh() {
        await this.fetchPerformances();
        GlobalEvents.$emit('local-refresh-done');
    }

    private getPerformanceName(performance) {
        // Get current locale id
        const locale = LanguageHandler.getLocaleId(this.$store.getters['settings/getLocale']);

        // Get matching translation
        const translation = performance.translations.find((t) => t.language_id.toString() === locale);

        if (translation) {
            return translation.title;
        } else {
            return performance.name;
        }
    }

    private selectABGroup(performances) {

        // Randomly show one of the trial groups
        const GROUP_A = 1082;
        const GROUP_B = 1083;

        // Random number that stays equal per device
        // const r = this.$store.getters['analytics/getDeviceID'] % 2;
        const r = this.$store.getters['settings/getRandomBool'];

        if (r) {
            performances = performances.filter(
                (performance) => performance.project_id !== GROUP_A
            );
        } else {
            performances = performances.filter(
                (performance) => performance.project_id !== GROUP_B
            );
        }

        return performances;
    }

    // Fetch list of active performances
    private async fetchPerformances() {
        this.loading = true;

        let data: Performance[] = await ApiHandler.request(ApiRoutes.getPerformancesRequest());

        // Show only performance from our selected host
        data = data.filter(
            (performance) => performance.host_id.toString() === this.$store.getters['settings/getHost'].id.toString());

        // Randomly hide one of the trial groups
        data = this.selectABGroup(data);

        this.performances = data;
        this.loading = false;
    }
}
